import React from 'react';
import S from './S';

class Navigator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: ('collapsed' in props ? props.collapsed: true),
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }

  toggleCollapse() {
    this.setState((state) => ({
      collapsed: !state.collapsed
    }));
  };

  render() {
    const { children } = this.props;
    const { collapsed } = this.state;

    return (
      <S.Navigator>
        {!collapsed && <S.NavigatorContent>{children}</S.NavigatorContent>}
        <S.NavigatorTrigger onClick={this.toggleCollapse}>
          <S.NavigatorLabel>Saved</S.NavigatorLabel>
        </S.NavigatorTrigger>
      </S.Navigator>
    );
  }
}

export default Navigator;
